import Aos from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";
import "./hero.css";
import pic03 from "../img/pic03.jpg";

function Hero() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <section className="hero-section " id="hero">
      <div data-aos="fade-up" className="column-11">
        <div className="content">
          <h2 className="title"> Al-Tatweer Al-Handsi </h2>
          <h3 className="description1">
            {" "}
            creative and unique solutions that it provides to clients by
            integrating technical expertise
          </h3>
          <a href="/#contact" className="btn">
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;
